import { render, staticRenderFns } from "./ProposalAgreementsProvider.vue?vue&type=template&id=268edeab&scoped=true&"
import script from "./ProposalAgreementsProvider.vue?vue&type=script&lang=js&"
export * from "./ProposalAgreementsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268edeab",
  null
  
)

export default component.exports